import { Component, OnInit,Input } from '@angular/core';
import { UserService } from '../api/';

@Component({
  selector: 'my-avatar',
  templateUrl: './my-avatar.component.html',
  styleUrls: ['./my-avatar.component.css']
})
export class MyAvatarComponent implements OnInit {
  avatar: any = null;
  @Input() imgClass: any = "avatar";

  constructor(private userService: UserService) {
    this.avatar = this.fetchAvatar();
  }

  fetchAvatar() {
    this.userService.getUserBasicInfo().subscribe((res) => {
        this.avatar = res.avatar;
    },(error) => {
      console.log(error);
    });
  }

  ngOnInit() {
    this.userService.getUserEventEmitter().subscribe((event) => {
      if (event.name === 'screenname:changed' || event.name === 'avatar:refresh') {
        this.avatar = this.fetchAvatar();
      }
    },
    (error) => {
      console.log(error);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/my-avatar/my-avatar.component.ts